import { isHttpClientError } from "@/http";

// Embodiment 컴포저 공용 에러 메시지를 해석한다. http client 에러면 서버 message 를, 그 외는 fallback 을 쓴다.
export function resolveEmbodimentErrorMessage(error: unknown): string {
  if (isHttpClientError(error)) {
    return error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "Embodiment 요청을 완료하지 못했습니다. 잠시 후 다시 시도해 주세요.";
}
